import { useEffect, useState } from "react"

interface BALANCE {
  finalBalance: string
}

export default function useBalanceUpdate(
  betInfo: {
    balance: string
    balance_before: string
    winAmount: string
  },
  showResult: boolean,
  balance: string,
): BALANCE {
  const [finalBalance, setFinalBalance] = useState<string>(balance)
  const [afterBalance, setAfterBalance] = useState<string>(betInfo.balance)
  const [beforeBalance, setBeforeBalance] = useState<string>(
    betInfo.balance_before,
  )

  useEffect(() => {
    setFinalBalance(balance)
  }, [balance])

  useEffect(() => {
    setAfterBalance(betInfo.balance)
    setBeforeBalance(betInfo.balance_before)
  }, [betInfo])

  useEffect(() => {
    if (+betInfo.winAmount > 0) {
      setFinalBalance(beforeBalance)
    } else {
      setFinalBalance(afterBalance)
    }
  }, [afterBalance, beforeBalance])

  useEffect(() => {
    setFinalBalance(afterBalance)
  }, [showResult])

  return { finalBalance }
}
